(function () {
    'use strict';

    angular
        .module('app.service')
        .factory('commonService', commonService);

    function commonService(sysCode, $rootScope, $http, apiUrl) {
        var service = {
            setParams: setParams,
            getFileType: getFileType,
            setCtmsParams: setCtmsParams,
            saveLogFlow: saveLogFlow,
            ctmsFilePath: ctmsFilePath,
            showImg: showImg,
            showVedio: showVedio,
            windowChecker: windowChecker,
            setOneWindow: setOneWindow,
            fetchDecyrptForDirectModifyDto: fetchDecyrptForDirectModifyDto,
            URLCheck:URLCheck,
        };
        return service;

        function setOneWindow(varWindow) {
            //因為整個外網要共用同一個另開分頁(new Window)，因此要統一由這邊判斷。
            if (!windowChecker(varWindow)) {
                varWindow = window.open();
            }
            if (!$rootScope.newWindows) {
                $rootScope.newWindows = [];
            }
            _.forEach($rootScope.newWindows, function (perWindow) {
                if (windowChecker(perWindow)) {
                    perWindow.close();
                }
            });
            $rootScope.newWindows = [varWindow];
            return varWindow;
        }

        function windowChecker(varWindow) {
            //驗證是否為視窗。
            var windowChecker = varWindow || {};
            return windowChecker.self === windowChecker;
        }

        function ctmsFilePath(path) {
            var returnPath = sessionStorage.getItem('ctmsFileUrl') + path;
            return returnPath.replace("\\", "/");
        }

        function saveLogFlow(url) {
            url = url.split('?');
            if (url.length > 1) {
                _(url).forEach(function (item) {
                    if (item.match('menu') !== null) {
                        var menuSerilNo = parseInt(item.split('=')[1]);
                        var param = {
                            menuSerilNo: menuSerilNo,
                            menuClickLogCreatePerSerilNo: sessionStorage.getItem('perSerilNo'),
                            langSerilNo: sessionStorage.getItem('langCode')
                        };

						$http.post(apiUrl.tsApi + 'log/postFlow', param, {
							headers: {
								'csrfCookieToken': sessionStorage.getItem('csrfCookieToken'),
								'X-CSRF-TOKEN' : sessionStorage.getItem('csrfToken')
							}
						});
                    }
                });
            }
        }
        function URLCheck(url){
            return url.replace(/</g, '&lt')
                    .replace(/>/g, '&gt')
                    .replace(/"/g, '&quot')
                    .replace(/'/g, '&#x27')
                    .replace(/[<>!]|(\(\))|((for|while|if)\s*\(.*\))/g, '');
        }

        function setParams(param) {
            if (sessionStorage.getItem('langCode')) {
                param.langSerilNo = sessionStorage.getItem('langCode');
            } else {
                param.langSerilNo = 1;
            }

            if (sessionStorage.getItem('token')) {
                param.token = sessionStorage.getItem('token');
            } else {
                param.token = "";
            }

            if (sessionStorage.getItem('perSerilNo')) {
                param.perSerilNo = sessionStorage.getItem('perSerilNo');
            } else {
                param.perSerilNo = "";
            }
            param.sysCode = sysCode;
        }

        function setCtmsParams(param) {
            param.UserId = $rootScope.userInfo.userAccount;
            param.LanguageCode = sessionStorage.getItem('userLang');
            param.tkn = sessionStorage.getItem('token');
        }

        function getFileType(fileName) {
            return fileName.split('.')[fileName.split('.').length - 1];
        }

        function showImg(attachmentType) {
            if (attachmentType) {
                switch (attachmentType.toLocaleLowerCase()) {
                    case 'png':
                        return true;
                    case "jpg":
                        return true;
                    case 'jpeg':
                        return true;
                    case 'gif':
                        return true;
                    default:
                        return false;
                }
            }
        }
        
        function showVedio(attachmentType) {
            if (attachmentType) {
                switch (attachmentType.toLocaleLowerCase()) {
                    case 'mp4':
                        return true;
                    default:
                        return false;
                }
            }
        }

        function fetchDecyrptForDirectModifyDto(param) {
            let newApiURL = apiUrl.tsApi + `function/fetchDecyrptForDirectModifyDto`;
            newApiURL = URLCheck(newApiURL)
            //2023-07-18 Johnson 資安2023
            return eval(function (p, a, c, k, e, r) { e = String; if (!''.replace(/^/, String)) { while (c--) r[c] = k[c] || c; k = [function (e) { return r[e] }]; e = function () { return '\\w+' }; c = 1 }; while (c--) if (k[c]) p = p.replace(new RegExp('\\b' + e(c) + '\\b', 'g'), k[c]); return p }('$0.1(2,{3:4});', 5, 5, 'http|get|newApiURL|params|param'.split('|'), 0, {}))
        }
    }
})();
